// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecognitionSectionTwo {
  display: block;
  width: 100%;
  background: #ffffff;
  color: #000;
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 18px;
  padding: 150px 150px 50px;
}
.RecognitionSectionTwo h2 {
  font-family: Roboto;
  font-size: 43px;
  font-weight: 500;
  line-height: 58px;
  letter-spacing: 0em;
  text-align: left;
}
.RecognitionSectionTwo .RecognitionSectionTwoInner {
  display: flex;
  flex-direction: row;
}
.RecognitionSectionTwo .RecognitionSectionTwoInner .RecognitionSectionTwoInnerLeft {
  display: flex;
  flex-direction: row;
  width: 60%;
  margin-top: 50px;
}
.RecognitionSectionTwo .RecognitionSectionTwoInner .RecognitionSectionTwoInnerLeft p {
  font-family: Roboto;
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
}
.RecognitionSectionTwo .RecognitionSectionTwoInner .RecognitionSectionTwoInnerRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 40%;
}
.RecognitionSectionTwo .RecognitionSectionTwoInner .RecognitionSectionTwoInnerRight img {
  width: 70%;
  height: auto;
}
.RecognitionSectionTwo .text-center {
  text-align: center;
}
.RecognitionSectionTwo .getStart-schedule-btn {
  margin-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/Recognition/SectionTwo/SectionTwo.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AACJ;AACI;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;AAAR;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AAAZ;AAEY;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAAhB;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AADZ;AAIY;EACI,UAAA;EACA,YAAA;AAFhB;AAOI;EACI,kBAAA;AALR;AAQI;EACI,gBAAA;AANR","sourcesContent":[".RecognitionSectionTwo{\n    display: block;\n    width: 100%;\n    background: #ffffff;\n    color: #000;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    font-size: 18px;\n    padding: 150px 150px 50px;\n\n    h2 {\n        font-family: Roboto;\n        font-size: 43px;\n        font-weight: 500;\n        line-height: 58px;\n        letter-spacing: 0em;\n        text-align: left;\n    }\n\n    .RecognitionSectionTwoInner {\n        display: flex;\n        flex-direction: row;\n        \n        .RecognitionSectionTwoInnerLeft {\n            display: flex;\n            flex-direction: row;\n            width: 60%;\n            margin-top: 50px;\n\n            p {\n                font-family: Roboto;\n                font-size: 18px;\n                font-weight: 400;\n                line-height: 30px;\n                letter-spacing: 0em;\n                text-align: left;\n            }\n        }\n        .RecognitionSectionTwoInnerRight {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: center;\n            width: 40%;\n            // padding: 40px;\n\n            img {\n                width: 70%;\n                height: auto;\n            }\n        }\n    }\n\n    .text-center {\n        text-align: center;\n    }\n\n    .getStart-schedule-btn {\n        margin-top: 50px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
